import { useState } from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EstateResultItem_OneViewNameInput } from 'queries';

type Props = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  setEssentialData: Function;
};

const useStyles = makeStyles(() => ({
  container: {
    paddingTop: '10px',
  },
  textField: {
    width: '100%',
  },
  title: {
    paddingTop: '10px',
  },
}));

export default function AddNameItem({ setEssentialData }: Props) {
  const classes = useStyles();
  const [nameInput] = useState<EstateResultItem_OneViewNameInput>({
    firstName: '',
    lastName: '',
    middleName: '',
    status: '',
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleInputChange = (e: any) => {
    switch (e.target.name) {
      case 'firstName':
        nameInput['firstName'] = e.target.value;
        break;
      case 'middleName':
        nameInput['middleName'] = e.target.value;
        break;
      case 'lastName':
        nameInput['lastName'] = e.target.value;
        break;
      case 'status':
        nameInput['status'] = e.target.value;
        break;
    }

    setEssentialData(nameInput);
  };

  return (
    <>
      <Typography variant="h5" className={classes.title}>
        Add a new alias
      </Typography>
      <Grid>
        <Grid className={classes.container}>
          <TextField
            className={classes.textField}
            fullWidth
            name="firstName"
            label="First"
            variant="outlined"
            autoFocus
            onChange={handleInputChange}
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
        <Grid className={classes.container}>
          <TextField
            className={classes.textField}
            fullWidth
            name="middleName"
            label="Middle"
            variant="outlined"
            autoFocus
            onChange={handleInputChange}
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
        <Grid className={classes.container}>
          <TextField
            className={classes.textField}
            fullWidth
            name="lastName"
            label="Last"
            variant="outlined"
            autoFocus
            onChange={handleInputChange}
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
        <Grid className={classes.container}>
          <TextField
            className={classes.textField}
            fullWidth
            name="status"
            label="Status (Current / Former)"
            variant="outlined"
            autoFocus
            onChange={handleInputChange}
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
      </Grid>
    </>
  );
}
